import React, { useContext } from 'react'
import SidebarMainSingle from './SidebarMainSingle'
import menuArray from "src/settings/menu";
import userContext from 'src/context/userContext';

export default function SidebarLinks() {
    const { user } = useContext(userContext)
    
    return (
        <nav className="flex justify-center flex-col gap-3 p-1 flex-1 overflow-auto">
            {menuArray.map((item, index) => (
                item.inMenu === true && (!(user?.role?.role === "superAdmin") || item.inSuperAdminMenu !== false)
                && <SidebarMainSingle item={item} key={index} />
            ))}
        </nav>
    )
}
